window.Shopify.loadFeatures([{
  name: 'consent-tracking-api',
  version: '0.1'
}], function (error) {
  if (error) {
    return;
  }
  var marketingAllowed = window.Shopify.customerPrivacy.currentVisitorConsent().marketing;
  if (marketingAllowed === 'yes') {
    siteTrackingScript();
  }
});
document.addEventListener('visitorConsentCollected', function (event) {
  var marketingAllowed = event.detail.marketingAllowed;
  if (marketingAllowed === true) {
    siteTrackingScript();
  }
});
function siteTrackingScript() {
  var script = document.createElement('script');
  script.setAttribute('src', 'https://r1-t.trackedlink.net/_dmpt.js');
  script.setAttribute('type', 'text/javascript');
  script.defer = true;
  document.head.appendChild(script);
}